import { FC } from 'react';
import { QuorumApprovalComponent } from '../../components/quorum/quorum-approval-component';

export const AdminQuorumApproval: FC = () => {
  /**
   * DOM
   */
  return <QuorumApprovalComponent />;
};
